import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, CanLoad, Route, Router, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';
import { hasPermission } from '../utils/role';

@Injectable({
	providedIn: 'root'
})
export class RoleGuard implements CanActivate, CanLoad {
	constructor(private router: Router) { }

	canActivate(route: ActivatedRouteSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
		const { moduleName, subModule, action } = route.data;
		const access = hasPermission(moduleName, subModule, action);
		return access ? true : this.router.parseUrl('/not-authorized');
	}

	canLoad(route: Route): boolean | UrlTree | Observable<boolean | UrlTree> | Promise<boolean | UrlTree> {
		if (route.data) {
			const { moduleName, subModule, action } = route.data;
			const access = hasPermission(moduleName, subModule, action);
			return access ? true : this.router.parseUrl('/not-authorized');
		}

		return false;
	}
}